const MAX_MOBILE_SCREEN_WIDTH = "600px"

export default { MAX_MOBILE_SCREEN_WIDTH }
